export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.status   = json.status
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries
      
      this.status.ratio = 0

      this.gmx_tableCoordinates('x', this.columns, 5)
      this.status.width = this.columns[this.columns.length-1].ex


      let total = this.rawData.TOTAL
      this.columns.forEach((d,i)=> {
        d.prog = this.rawData[d.code] / total
        d.value = this.rawData[d.code]
        if(this.rawData[d.code + '_WK']) d.week = this.rawData[d.code + '_WK']
      })

    },

  }
}